<template>
  <div class="error-page custom-scroll">
    <closer closer-size="13" @click="goBakOneStep" />
    <div class="page-content-wrap">
      <div>
        <img class="error-page__image" src="~img/404.svg" alt="not-found-picture" />
      </div>
      <div>
        <h1 class="error-page__title" data-cy="error-page-title" v-text="$t('not-found-page-title')" />
      </div>
      <div>
        <kw-button
          :button-text="$t('back-to-dashboard')"
          button-type="primary"
          class="error-page__back"
          @click="goHomePage"
        />
      </div>
      <div>
        <div class="error-page__help-wrapper">
          <p class="error-page__help-tip">
            {{ $t('having-trouble') }}
            <a class="error-page__contact" href="mailto: support@keyword.com">
              {{ $t('contact-us') }}
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound',
  methods: {
    goBakOneStep() {
      this.$router.go(-1);
    },
    goHomePage() {
      this.$router.push({ name: 'Overview' });
    },
  },
};
</script>
